import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69e18e148485e200149a990e_1787077290133_af3b3adb/propinsight/src/app/sign-up-login-screen/components/AuthPanel.tsx");
